const versionRedirectSelector = '.version-redirect';

function redirectUrl(a) {
    const searchVendor = document.querySelector('meta[name="search-vendor"]').getAttribute('content');
    const navSlug = document.querySelector('meta[name="cv-nav-slug"]').getAttribute('content');
    const oemSlug = document.querySelector('meta[name="cv-oem-slug"]').getAttribute('content');
    const searchBarSelector = searchVendor === 'coveo' ? '.CoveoOmnibox input' : '#search-input';
    const searchBar = document.querySelector(searchBarSelector);
    const query = searchBar ? searchBar.value : '';
    const pathName = window.location.pathname + window.location.search + window.location.hash;
    return `${a.getAttribute('href')}?q=${query}&oem=${oemSlug}&nav=${navSlug}&path=${encodeURIComponent(pathName)}`;
}

function versionsRedirectHandler(e) {
    const versionRedirect = e.target.closest(versionRedirectSelector);
    if (versionRedirect) {
        e.preventDefault();
        window.location = redirectUrl(versionRedirect);
    }
}

export default versionsRedirectHandler;